import qs from 'query-string'

export const cleanParams = <Defaults extends Record<string, any>, Params extends Record<string, any>>(
  defaults: Defaults,
  params: Params,
  whitelist: string[] = [],
) => {
  return Object.keys(params)
    .filter((key) => {
      const differsFromDefault = typeof defaults[key] === 'undefined' || params[key] !== defaults[key]
      const inWhitelist = whitelist.length === 0 || whitelist.includes(key)
      return differsFromDefault && inWhitelist
    })
    .reduce((obj, key) => ({ ...obj, [key]: params[key] }), {})
}
const options = { parseNumbers: true, parseBooleans: true, arrayFormat: 'comma' as const }

export const getUrlParams = () => qs.parse(window.location.search, options) as any
